<template>
  <transition name="toast-fade">
    <div
      class="toast"
      :class="toastClass"
      v-show="isShow"
      @mouseenter="onMouseenter"
      @mouseleave="onMouseleave"
    >
      <button class="toast-close-button" @click="hide">×</button>
      <div class="toast-container">
        <div class="toast-title">{{ title }}</div>
        <div class="toast-content">{{ content }}</div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data: () => ({
    // list: [],
    title: null, //toast标题
    content: null, //toast内容
    type: null, //toast类型
    isShow: false, //toast是否显示
    timer: null,
    onShow: () => {},
    onHide: () => {},
  }),
  computed: {
    // 样式'success, error, warning, default'
    toastClass() {
      return this.type ? "toast-" + this.type : null;
    },
  },
  methods: {
    // 显示
    show(params) {
      let { content, title, onShow, onHide, type } = params;
      this.type = type;
      this.content = content;
      this.title = title;
      this.onShow = onShow;
      this.onHide = onHide;
      this.isShow = true;
      this.setTimer();
      setTimeout(() => {
        this.isShow = false;
      }, 3000); //3s后自动关闭
    },

    // 隐藏
    hide() {
      this.isShow = false;
    },
    // 计时器
    setTimer() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.isShow = false;
      }, 4000);
    },
    // 鼠标移至组件时保持显示状态
    onMouseenter() {
      clearTimeout(this.timer);
    },
    // 鼠标移开组件时重新定时
    onMouseleave() {
      if (this.isShow) this.setTimer();
    },
  },
  watch: {
    isShow(val) {
      if (val && typeof this.onShow === "function") {
        this.onShow();
      } else if (!val && typeof this.onHide === "function") {
        this.onHide();
      }
    },
  },
};
</script>
<style>
.toast {
  position: fixed;
  top: 15px;
  right: 15px;
  display: block;
  width: 200px;
  overflow: hidden;
  box-shadow: 0 0 6px #999;
  /* opacity: 0.8; */
  border-radius: 3px 3px;
  padding: 14px 13px;
  background-position: 15px center;
  background-repeat: no-repeat;
  color: #333;
  background-color: #f0f3f4;
  z-index: 99999;
}

.toast-success {
  color: #67c23a;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  padding: 15px;
}

.toast-error {
  color: #f56c6c;
  background-color: #fef0f0;
  border-color: #fde2e2;
  padding: 15px;
}

.toast-warning {
  color: #e6a23c;
  background-color: #fdf6ec;
  border-color: #faecd8;
  padding: 15px;
}

.toast:hover {
  opacity: 1;
  box-shadow: 0 0 18px #888;
  transition: all 200ms ease;
}

.toast-container {
  vertical-align: middle;
}

.toast-fade-enter,
.toast-fade-leave-active {
  opacity: 0;
  transform: translateX(100%);
}

.toast-fade-leave-active,
.toast-fade-enter-active {
  transition: all 400ms cubic-bezier(0.36, 0.66, 0.04, 1);
}

.toast-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 2px;
}
.toast-content {
  font-size: 14px;
}

.toast-close-button {
  padding: 2px 2px;
  border: none;
  background: transparent;
  position: relative;
  right: -10px;
  top: -15px;
  float: right;
  font-size: 20px;
  /* font-weight: bold;
  color: #ffffff; */
  -webkit-text-shadow: 0 1px 0 #ffffff;
  text-shadow: 0 1px 0 #ffffff;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
  filter: alpha(opacity=80);
}
</style>
